module.exports = __webpack_public_path__ + "img/29.dfcba2b3.png";